/* ==========================================================================
   MiaouLab - permutation des images de la galerie produit.

   Au clic sur une image secondaire, elle prend la place de la grande image,
   et la grande image prend exactement la place de la secondaire cliquee.
   C'est un echange de position, pas une mise en avant : les deux noeuds
   sont intervertis dans le DOM.

   Pourquoi un echange de noeuds plutot qu'une classe : la grande image est
   definie en CSS par .product__media-item:first-child. Deplacer une classe
   aurait fait s'etaler un element reste au milieu de la grille. En
   intervertissant les deux <li>, la mise en page reste juste sans une seule
   ligne de CSS supplementaire.

   Contraintes respectees :
   - actif uniquement au-dela de 990 px, la ou la galerie est une grille.
     En dessous, Dawn affiche un carrousel a defilement : on n'y touche pas.
   - aucune image dupliquee, aucun rechargement, aucun media modifie dans
     Shopify : seuls les <li> existants changent de place.
   - la synchronisation des variantes continue de fonctionner. Dawn place le
     media de la variante en tete de liste : il devient donc la grande image.
   - fonctionne pour n'importe quel produit, quel que soit le nombre de
     medias. Rien n'est code en dur.

   L'ecoute est en phase de CAPTURE avec stopPropagation : c'est ce qui
   empeche le bouton de Dawn d'ouvrir la fenetre modale du media. Sans cela,
   le clic ouvrait le modal au lieu de permuter.
   ========================================================================== */

(function () {
  var LARGEUR_GRILLE = 990;

  var liste = document.querySelector('.product__media-wrapper .product__media-list');
  if (!liste) return;

  function enGrille() {
    return window.innerWidth >= LARGEUR_GRILLE;
  }

  function permuter(a, b) {
    if (!a || !b || a === b) return;
    var repere = document.createComment('mia-permutation');
    a.parentNode.insertBefore(repere, a);
    b.parentNode.insertBefore(a, b);
    repere.parentNode.insertBefore(b, repere);
    repere.parentNode.removeChild(repere);
  }

  liste.addEventListener(
    'click',
    function (e) {
      if (!enGrille()) return;

      var cible = e.target.closest ? e.target.closest('.product__media-item') : null;
      if (!cible) return;

      var principal = liste.firstElementChild;
      if (!principal || cible === principal) return;

      e.preventDefault();
      e.stopPropagation();

      permuter(cible, principal);

      // Dawn marque le media affiche avec is-active : on garde l'etat coherent.
      principal.classList.remove('is-active');
      cible.classList.add('is-active');

      var bouton = cible.querySelector('.product__media-toggle');
      if (bouton) bouton.focus({ preventScroll: true });
    },
    true
  );
})();
